import React from "react";
import { Chip } from "../../../../../../chip";

export const BaseChip = ({
  children,
  onDelete,
  disabled = false,
}: {
  children: React.ReactNode;
  onDelete?: () => void;
  disabled?: boolean;
}) => {
  return (
    <Chip sentiment="neutral" variant="outlined" onDelete={onDelete} disabled={disabled}>
      {children}
    </Chip>
  );
};
